import { t } from "i18next";

export class DeviationStatus {
  static NOT_STARTED = new DeviationStatus(0, t("main.notStarted"), "#cf2424"); // red
  static BEING_SOLVED = new DeviationStatus(1, t("main.beingSolved"), "#ffa800"); // orange
  static SOLVED = new DeviationStatus(2, t("main.solved"), "#2f9d00"); // green
  static ALL = [DeviationStatus.NOT_STARTED, DeviationStatus.BEING_SOLVED, DeviationStatus.SOLVED];

  id: number;
  name: string;
  color: string;

  constructor(id: number, name: string, color: string) {
    this.id = id;
    this.name = name;
    this.color = color;
  }

  static getStatusWithId(id: number): DeviationStatus {
    const status = DeviationStatus.ALL.find((s) => s.id === id);
    if (status) return status;

    return DeviationStatus.NOT_STARTED;
  }
}
